export interface IMode {
  name: string;
  code: string;
}
export const Mode: IMode[] = [
  {
    name: "Black Only",
    code: "black",
  },
  {
    name: "Full Colour",
    code: "colour",
  },
  {
    name: "Mix",
    code: "mix",
  },
];
